// @flow

import _ from 'lodash';

import ApiObject from './ApiObject';
import ApiConstants from '../constants/ApiConstants';

import OpeningHours from './OpeningHours';
import Address from './Address';
import RestaurantColors from './RestaurantColors';
import RestaurantLegal from './RestaurantLegal';
import GeoPt from './GeoPt';
import CRMSettings from './CRMSettings';
import BookingSettings from './booking/BookingSettings';
import OrderSettings from './order/OrderSettings';
import ViewConstants from '../constants/ViewConstants';

export default class Restaurant extends ApiObject {

  static Features = ApiConstants.RestaurantFeatures;

  id: string = '';

  name: string = '';

  externalId: string = '';

  /**
   * Ratio 254x254
   */
  logo: string = '';

  /**
   * Ratio 640x425
   */
  picture: string = '';

  phonePub: string = '';

  webSitePub: string = '';

  emailPub: string = '';

  tag: string = '';

  facebookPub: string = '';

  twitterPub: string = '';

  legal: RestaurantLegal = new RestaurantLegal();

  geoPt: GeoPt;

  desc: string = '';

  payMode: number; // int

  address: Address = new Address();

  distance: number; // float

  currency: string;

  manufactureDelay: number; // long

  colors: RestaurantColors = new RestaurantColors();

  /**
   * Bitefield. The features enabled for the restaurant (pay, order, ).
   */
  features: number; // long

  openingHours: OpeningHours = new OpeningHours();

  password: string = '';

  pos: string = '';

  posUrl: ?string = null;
  posId: ?string = null;

  posCustomerId: ?string = null;
  posCommentId: ?string = null;
  posTipArticleId: string = null;
  posPriceLevelId: string = null;
  posUseQsrOrderNumber: string = null;
  posUseTransNum: string = null;
  posSendArticleLineNum: string = null;
  posEncryptionKey: ?string = null;


  // -- menu

  menuPicture: ?string = null;

  menuPdf: ?string = null;

  // -- booking

  bookingSettings: BookingSettings = new BookingSettings();

  // -- Order

  orderSettings: OrderSettings = new OrderSettings();

  // -- crm settings

  crmSettings = new CRMSettings();

  // -- bank
  acquirer = null
  psp = null
  pspSettings = null

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    this.openingHours = new OpeningHours();
    this.openingHours.fromJson(data.openingHours);

    this.address = new Address();
    this.address.fromJson(data.address);

    this.colors = new RestaurantColors();
    this.colors.fromJson(data.colors);

    this.legal = new RestaurantLegal();
    this.legal.fromJson(data.legal);

    this.crmSettings = new CRMSettings();
    this.crmSettings.fromJson(data.crmSettings);

    this.geoPt = new GeoPt();
    this.geoPt.fromJson(data.geoPt);

    this.orderSettings = new OrderSettings();
    this.orderSettings.fromJson(data.orderSettings);
  }

  // -- tools
  getCoverPicture(): string {
    if (_.isNull(this.picture) || _.isEmpty(this.picture)) {
      return ViewConstants.IMAGE_DEFAULT_RESTAURANT();
    }
    return this.picture;
  }

  getLogoPicture(): string {
    if (_.isNull(this.logo) || _.isEmpty(this.logo)) {
      return ViewConstants.IMAGE_DEFAULT_RESTAURANT_LOGO();
    }
    return this.logo;
  }

  // -- Credit card
  isAcceptingCreditCardType(creditCardType: number): boolean {
    return (creditCardType & this.payMode) !== 0;
  }

  isAcceptingVisa(): boolean {
    return this.isAcceptingCreditCardType(ApiConstants.CreditCardType.VISA);
  }

  isAcceptingAmex(): boolean {
    return this.isAcceptingCreditCardType(ApiConstants.CreditCardType.AMERICAN_EXPRESS);
  }

  isAcceptingMastercard(): boolean {
    return this.isAcceptingCreditCardType(ApiConstants.CreditCardType.MASTERCARD);
  }

  // -- features

  haveFeature(feature: number): boolean {
    return (feature & this.features) !== 0;
  }

  haveFeatureOrder(): boolean {
    return this.haveFeature(Restaurant.Features.ORDER);
  }

  haveFeaturePayment(): boolean {
    return this.haveFeature(Restaurant.Features.PAYMENT);
  }

  haveFeatureBooking(): boolean {
    return this.haveFeature(Restaurant.Features.BOOKING);
  }

  haveFeatureReview(): boolean {
    return this.haveFeature(Restaurant.Features.REVIEW);
  }

  haveFeatureNews(): boolean {
    return this.haveFeature(Restaurant.Features.NEWS);
  }

}
